const STORAGE_PREFIX = 'setup-site-state';

export const getSetupStateKey = (userId) =>
  userId ? `${STORAGE_PREFIX}:${userId}` : STORAGE_PREFIX;

export const readSetupState = (storageKey) => {
  if (typeof window === 'undefined' || !storageKey) {
    return null;
  }

  try {
    const rawValue = window.localStorage.getItem(storageKey);
    if (!rawValue) {
      return null;
    }

    const parsed = JSON.parse(rawValue);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (error) {
    console.error('Error reading setup state', error);
    return null;
  }
};

export const writeSetupState = (storageKey, state) => {
  if (typeof window === 'undefined' || !storageKey) {
    return;
  }

  try {
    window.localStorage.setItem(storageKey, JSON.stringify(state));
  } catch (error) {
    console.error('Error saving setup state', error);
  }
};
